import {
  Component,
  Inject,
  Input,
  OnChanges,
  PLATFORM_ID,
  SimpleChanges,
} from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { LinkComponent } from '../../atoms/link/link.component';
import { IconComponent } from '../../atoms/icon/icon.component';
import { Colors, Sizes } from '../../../shared/enums/shared.enums';
import { HrefType } from '../../../shared/enums/href-type.enums';
import LinkType from '../../../shared/enums/link-type.enums';

import { Breadcrumbs } from '../../../shared/interfaces/navigation-page.interface';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
  selector: 'hdi-breadcrumbs',
  standalone: true,
  imports: [
    CommonModule,
    FontAwesomeModule,
    LinkComponent,
    IconComponent,
    NgxSkeletonLoaderModule,
  ],
  templateUrl: './breadcrumb.component.html',
  styleUrl: './breadcrumb.component.scss',
  host: {
    id: crypto.randomUUID().toString(),
  },
})
export class BreadcrumbsComponent implements OnChanges {
  @Input() breadcrumbs: Breadcrumbs[] = [];

  breadcrumbType = LinkType.BREADCRUMB;
  breadcrumbNoIconType = LinkType.BREADCRUMB_NO_ICON;
  Colors = Colors;
  Sizes = Sizes;
  BreadcrumbHrefType = HrefType;

  constructor(
    private readonly sanitizer: DomSanitizer,
    @Inject(PLATFORM_ID) private readonly platformId: object
  ) {}

  public isLoading = true;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['breadcrumbs']) {
      if (isPlatformBrowser(this.platformId)) {
        this.isLoading = false;
      }
    }
  }

  getMetaTagHtml(index: number): SafeHtml {
    const metaTag = `<meta itemprop="position" content="${index + 1}" />`;
    return this.sanitizer.bypassSecurityTrustHtml(metaTag);
  }
}
